/* assets/reviews.js - minimal, for accessibility or future features */
document.addEventListener('DOMContentLoaded', function(){
  // nothing required now; placeholder for progressive enhancement
});